import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError, shareReplay, tap} from 'rxjs/operators';
import {BesprechungStoreService} from '../stores/besprechung-store.service';
import {BesprechungService} from '../../../generated-api';

@Injectable({
  providedIn: 'root'
})
export class BesprechungPageService {

  constructor(private store: BesprechungStoreService, private besprechungService: BesprechungService) {
  }

  getBesprechungWithStore(id): Observable<any> {
    this.store.loading = true;
    return this.besprechungService.getBesprechung(id, 'body').pipe(shareReplay(1), catchError(err => {
        this.store.loading = false;
        this.store.searchError = err.message;
        this.store.besprechung = null;
        return of(null);
      }),
      tap((value: any) => {
        this.store.loading = false;
        this.store.searchError = '';
        this.store.besprechung = value;
      })
    );
  }

  getBesprechung(id, cb): void {
    this.store.loading = true;
    this.store.searchError = null;
    this.store.besprechung = null;
    this.besprechungService.getBesprechung(id, 'body', false, {}).pipe(shareReplay(1), catchError(err => {
      this.store.loading = false;
      this.store.searchError = err.message;
      this.store.besprechung = null;
      return throwError(err);
    })).subscribe((value: any) => {
      this.store.loading = false;
      this.store.searchError = null;
      this.store.besprechung = value;
      if (cb) {
        cb(value);
      }
    });
  }
}
